export function useCrudOperation() {
  const indexOfItems = (state, object) => {
    let findIndex = state.findIndex((data) => data.id === object.id);
    return findIndex;
  };

  const findById = (state, id) => {
    return state.find((data) => data.id === id);
  };

  const deleteAllById = (state, deleteIds) => {
    state = state.filter((data) => !deleteIds.includes(data.id));

    return state;
  };

  const add = (state, object) => {
    const index = indexOfItems(state, object);
    if (index === -1) state.push(object);

    return state;
  };

  const deleteItem = (state, object) => {
    const index = indexOfItems(state, object);
    if (index > -1) state.splice(index, 1);

    return state;
  };

  const update = (state, object) => {
    const index = indexOfItems(state, object);
    if (index > -1) {
      for (const key in object) {
        // eslint-disable-next-line no-prototype-builtins
        if (state[index].hasOwnProperty(key)) {
          state[index][key] = object[key];
        }
      }
    }
    return state;
  };

  return { update, deleteItem, add, deleteAllById, findById };
}
